export default __webpack_public_path__ + "static/media/muted-speaker.f5835e14.svg";